<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="justify-content-start mb-5">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <b-row>
          <b-col sm="6" class="form-group" v-if="isEditable">
            <form-write-group-label-input v-model="Name" isMandatory
              :inputLabel="$t('common.routing.flagCACP.entity_group.name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group" v-else>
            <form-read-group-label-input isMandatory
              :inputLabel="$t('common.routing.flagCACP.entity_group.name')"
              :inputValue="Name">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="justify-content-end">
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('details')">
              <span>{{ $t('common.cncl') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="switchMode('edit')">
              <i class="fa-light fa-pencil"></i>
              <span>{{ $t('common.edit_label') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="deleteEntityGroup">
              <i class="fa-light fa-trash"></i>
              <span>{{ $t('common.del_label') }}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
            <b-button variant="primary"
              @click="editEntityGroup">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
            <b-button variant="primary"
              @click="addEntityGroup">
              <i class="fa-light fa-save"></i>
              <span>{{$t('common.sve')}}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import {loadPage} from '@/helpers/routing'
import FormWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue";
import FormReadGroupLabelInput from "@/components/common/formReadGroupLabelInput.vue";

export default {
  name: "EntityGroupDetails",
  components: {
    FormReadGroupLabelInput,
    FormWriteGroupLabelInput,
    'back-button': backButton,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.entity_group_details')
        case 'details':
          return this.$t('Webheader.entity_group_details')
        case 'add':
        default:
          return this.$t('Webheader.entity_group_add')
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      returnUrl: '',
      Name: '',
      originalName: '',
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.returnUrl = '/entityGroup/'

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getEntityGroup()
      this.activateSpinner = false
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addEntityGroup () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        Name: this.Name,
        IdEntityGroup: this.id
      }
      this.$engine.firstOn().entityGroup.addEntityGroup(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.flagCACP.entity_group.added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/entityGroup/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.routing.flagCACP.entity_group.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that)
        }
      })
    },
    deleteEntityGroup () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.routing.flagCACP.entity_group.deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdEntityGroup: that.id
              }
              that.$engine.firstOn().entityGroup.deleteEntityGroup(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.routing.flagCACP.entity_group.deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: '/entityGroup/'})
              })
              .catch((e) => {
                if (e.response.status === 400 && e.response.data.errors) {
                  const errors = e.response.data.errors

                  errors.forEach((error) => {
                    if (error.error === "Deletion Error") {
                      that.okMessageBox(that.$t('common.routing.flagCACP.entity_group.unable_del'))
                    }
                  })
                } else {
                  errorMessageAlert(e, that, that.$i18n)
                }
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editEntityGroup () {

      if (this.formHasError()) {
        return
      }

      let that = this
      let params = {
        IdEntityGroup: this.id,
        Name: this.Name
      }
      this.$engine.firstOn().entityGroup.editEntityGroup(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.routing.flagCACP.entity_group.edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/entityGroup/'})
      })
      .catch((e) => {
        if (e.response.status === 400 && e.response.data.errors) {
          const errors = e.response.data.errors

          errors.forEach((error) => {
            if (error.error === "Invalid Name") {
              that.okMessageBox(that.$t('common.routing.flagCACP.entity_group.name_exist_db'))
            }
          })
        } else {
          errorMessageAlert(e, that, that.$i18n)
        }
      })
    },
    formHasError () {
      if (this.Name === undefined || this.Name.length === 0) {
        this.okMessageBox(this.$t('common.routing.flagCACP.entity_group.name_missing'))
        return true
      }
      return false
    },
    getEntityGroup () {
      let params = {
        IdEntityGroup: this.id
      }
      let that = this
      this.$engine.firstOn().entityGroup.getEntityGroup(params)
      .then(resp => {
        that.Name = resp.data.EntityGroup.Name
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.Name = this.originalName
      }
      this.formType = mode
    }
  }
}
</script>
